<div mat-dialog-content class="mt--sm">
  <span class="color--navy" style="overflow-wrap: break-word;">{{ data.message }}</span>
</div>

<div class="row row--space-between" mat-dialog-actions>
  @if(data.cancelButton) {
  <button mat-button mat-dialog-close class="secondary-button column--12 column-sm--6 rounded">
    <span class="icon-x mr--xs"></span>
    <span>{{ data.cancelButton }}</span>
  </button>
  }
  <button mat-button class="primary-button column--12 column-sm--6 rounded" (click)="onConfirm()">
    <span class="icon-check mr--xs"></span>
    <span>{{ data.confirmButton }}</span>
  </button>
</div>
